let VideoService = function (Restangular) {
  const ServiceAPI = Restangular.all("admin/dashboard/banner");

  let getList = (query) => {
    return Restangular.all("admin/dashboard/banner").customGET("", query);
  };

  let save = (resource) => {
    const api = Restangular.all("admin/mobile/banner")
    if (resource.id) {
      let copyData = angular.copy(resource);
      delete copyData.id;
      return ServiceAPI.customPUT(copyData, resource.id);
    } else {
      return api.post(resource);
    }
  };

  let getVideo  = (id) => {
    return ServiceAPI.customGET(`${id}`)
  }

  let destroy = (resource) => {
    return ServiceAPI.customDELETE(resource.id);
  };

  return { getList, save, destroy, getVideo };
};

VideoService.$inject = ["Restangular"];

export default VideoService;



// WEBPACK FOOTER //
// ./client/app/components/page/video.service.js